import styled, { keyframes } from "styled-components";

const goalBg = keyframes`
    2.5% { background: #db3131; }
    85% { background: #db3131; }
`;

const goalLetter = keyframes`
    0% { opacity: 0; }
    5% { opacity: 1; }
    95% { opacity: 1; display: none; }
  `;

const goalFade = keyframes`
    5% { 
        opacity: 0;
        display: none;
        color:  #db3131;
     }
    85% { 
        opacity: 0;
        display: none;
        color:  #db3131;
     }
    100% { 
        opacity: 1;
        display: block;
        color: inherit;
    }
`;

export const StyledGoal = styled.div`
  height: 100%;
  width: 100%;
  width: inherit;
  border-radius: inherit;
  display: flex;
  justify-content: center;
  align-items: center;

  &.--is-goal {
    animation: ${goalBg} 20s ease-in-out;

    .mls-c-scorebug__wrapper {
      opacity: 0;
      position: absolute;
      animation: ${goalFade} 8s ease;
      animation-fill-mode: forwards;
    }

    .goal-anim {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      z-index: 1;

      span:nth-child(1) {
        animation: ${goalLetter} 7s 0.1s ease-in-out;
      }
      span:nth-child(2) {
        animation: ${goalLetter} 7s 0.2s ease-in-out;
      }
      span:nth-child(3) {
        animation: ${goalLetter} 7s 0.3s ease-in-out;
      }
      span:nth-child(4) {
        animation: ${goalLetter} 7s 0.4s ease-in-out;
      }
    }
  }
`;

export const StyledGoalWrapper = styled.div`
  display: none;

  span {
    opacity: 0;
  }
`;

export const StyledGoalLetter = styled.span``;
